import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../../shared/redux/hooks'
import SaberLayout from './SaberLayout'

const SABER_READ_PERMISSIONS = ['saber:read']

export const Saber: React.FC = () => {
  const { permissions } = useAppSelector((state) => state.app)

  const hasSaber = permissions?.some((p) => SABER_READ_PERMISSIONS.includes(p)) ?? false
  if (!hasSaber) {
    return <Navigate to="/" replace />
  }

  return <SaberLayout />
}

export default Saber
